import { render, staticRenderFns } from "./Receipt-detail.vue?vue&type=template&id=660f158f"
import script from "./Receipt-detail.vue?vue&type=script&lang=js"
export * from "./Receipt-detail.vue?vue&type=script&lang=js"
import style0 from "./Receipt-detail.vue?vue&type=style&index=0&id=660f158f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports